<script setup>
import { ref, computed, defineProps } from 'vue'
import { useI18n } from 'vue-i18n'
import { getCookie, getLocalItem } from '@/utils/token'
import { useRouter, useRoute } from 'vue-router'
import { useStore, mapGetters, mapState } from 'vuex'

const { t, locale } = useI18n()

const router = useRouter()
const route = useRoute()
const store = useStore()

const props = defineProps({
  source: String,
  routeSource: String,
  originalShow: Boolean,
  cropList: Array,
})
</script>

<template>
  <span v-if="source === 'face'">
    <span v-if="routeSource === 'face_mask_detection'">
      <!-- {{
        $t('homepage.cropMaskText', {
          num: originalShow ? cropList.length : cropList.length - 1,
        })
      }} -->
    </span>
    <span v-else>
      {{
        $t('homepage.cropText', {
          num: originalShow ? cropList.length : cropList.length - 1,
        })
      }}
    </span>
  </span>
  <span v-else-if="source === 'body'">
    <span v-if="routeSource === 'body_hand_keypoint'">
      {{
        $t('homepage.cropHandText', {
          num: originalShow ? cropList.length : cropList.length - 1,
        })
      }}
    </span>
    <span
      v-else-if="
        [
          'body_head_shoulder_detection',
          'body_detection',
          'body_keypoint',
          'body_attribute',
        ].includes(routeSource)
      "
    >
      {{
        $t('homepage.cropHumanBodyText', {
          num: originalShow ? cropList.length : cropList.length - 1,
        })
      }}
    </span>
    <span
      v-else-if="
        ['body_crowd_density', 'body_human_segmentation'].includes(routeSource)
      "
    />
    <span v-else-if="routeSource === 'body_driver_monitoring'">
      {{
        $t('homepage.cropDriverText', {
          num: originalShow ? cropList.length : cropList.length - 1,
        })
      }}
    </span>
    <span v-else-if="routeSource === 'body_helmet_detection'">
      {{
        $t('homepage.cropHelmetText', {
          num: originalShow ? cropList.length : cropList.length - 1,
        })
      }}
    </span>
    <span v-else-if="routeSource === 'body_gesture_recognition'">
      {{
        $t('homepage.imageGestureText', {
          num: originalShow ? cropList.length : cropList.length - 1,
        })
      }}
    </span>
    <span v-else-if="routeSource === 'body_reflective_vest_detection'">
      {{
        $t('homepage.imageVestText', {
          num: originalShow ? cropList.length : cropList.length - 1,
        })
      }}
    </span>
    <!-- 空值 -->
    <span v-else-if="routeSource === 'body_detection_smoking'"> </span>
    <span v-else>{{
      $t('homepage.cropBodyText', {
        num: originalShow ? cropList.length : cropList.length - 1,
      })
    }}</span>
  </span>
  <span v-else-if="source === 'qr'">{{
    $t('homepage.qrText', {
      num: originalShow ? cropList.length : cropList.length - 1,
    })
  }}</span>
  <span v-else-if="source === 'ocr'">
    <span
      v-if="
        [
          'ocr_business_license',
          'ocr_bank_card',
          'ocr_invoice_information',
          'ocr_driver_license',
        ].includes(routeSource)
      "
    />
    <span v-else-if="routeSource === 'ocr_water_meter'">
      <!-- {{
        $t('homepage.ocrWaterMeterText', {
          num: originalShow ? cropList.length : cropList.length - 1,
        })
      }} -->
    </span>
    <span v-else>{{
      $t('homepage.ocrText', {
        num: originalShow ? cropList.length : cropList.length - 1,
      })
    }}</span>
  </span>
  <span v-else-if="source === 'vehicle'">{{
    $t('homepage.vehicleText', {
      num: originalShow ? cropList.length : cropList.length - 1,
    })
  }}</span>
  <span v-else-if="source === 'image'">
    <span v-if="routeSource === 'image_tech_super_resolution'"></span>
    <span v-else>{{
      $t('homepage.imageText', {
        num: originalShow ? cropList.length : cropList.length - 1,
      })
    }}</span>
  </span>
  <span v-else-if="source === 'detection'">{{
    $t('homepage.imageFireText', {
      num: originalShow ? cropList.length : cropList.length - 1,
    })
  }}</span>
</template>

<style lang="scss" scoped>
span {
  font-size: 16px;
  color: #666;
}
.flex {
  display: flex;
}
.mb10 {
  margin-bottom: 10px;
}
.ml0 {
  margin-left: 0 !important;
  margin-right: 5px;
}
.attribute {
  min-width: 140px;
  display: inline-block;
}
.emotion-progress {
  // display: flex;
  a {
    margin-left: 0 !important;
    margin-right: 40px;
  }

  .progress {
    margin-right: 40px;
    flex: 1;
  }
}
.right-dec {
  margin: 10px;
  a {
    margin-left: 30px;
    color: #ff0000;
    word-wrap: break-word;
  }
}
</style>
